'use client';

import { useEffect, useMemo, useState } from 'react';

import { formatDateRangeWithTimeZone } from '@/lib/date-time-core';

type MaintenanceRangeTextProps = {
  start: string;
  end: string;
  fallbackTimezone: string;
  initialTimezone?: string | null;
  className?: string;
};

export function MaintenanceRangeText({
  start,
  end,
  fallbackTimezone,
  initialTimezone,
  className,
}: MaintenanceRangeTextProps) {
  const [resolvedTimezone, setResolvedTimezone] = useState<string>(
    initialTimezone ?? fallbackTimezone
  );

  useEffect(() => {
    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (tz) {
        setResolvedTimezone(tz);
      }
    } catch (error) {
      // ignore – fallback timezone will be used
    }
  }, [fallbackTimezone, initialTimezone]);

  const formatted = useMemo(() => {
    return formatDateRangeWithTimeZone({
      start: new Date(start),
      end: new Date(end),
      timezone: resolvedTimezone,
    });
  }, [start, end, resolvedTimezone]);

  return (
    <span className={className} suppressHydrationWarning>
      {formatted}
    </span>
  );
}
